var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8434_77795)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6021 11.7778C24.8891 11.4075 23.1113 11.4075 21.3983 11.7778L20.4169 14.6667C19.4354 15.0371 18.5187 15.5648 17.7039 16.2315L14.7131 15.6389C13.5372 16.9352 12.6576 18.4722 12.1113 20.1389L14.1205 22.4353C13.9631 23.4723 13.9631 24.5277 14.1205 25.5648L12.1113 27.8612C12.6576 29.5278 13.5372 31.0649 14.7131 32.3611L17.7039 31.7685C18.5187 32.4352 19.4354 32.9629 20.4169 33.3333L21.3983 36.2222C23.1113 36.5926 24.8891 36.5926 26.6021 36.2222L27.5835 33.3333C28.565 32.9629 29.4817 32.4352 30.2966 31.7685L33.2873 32.3611C34.4632 31.0649 35.352 29.5278 35.8891 27.8612L33.8799 25.5648C34.0373 24.5277 34.0373 23.4723 33.8799 22.4353L35.8891 20.1389C35.352 18.4722 34.4632 16.9352 33.2873 15.6389L30.2966 16.2315C29.4817 15.5648 28.565 15.0371 27.5835 14.6667L26.6021 11.7778ZM24.0002 20.25C26.0743 20.25 27.7503 21.9352 27.7503 24C27.7503 26.0741 26.0743 27.7501 24.0002 27.7501C21.9354 27.7501 20.2502 26.0741 20.2502 24C20.2502 21.9352 21.9354 20.25 24.0002 20.25Z",
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8434_77795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.6a17ade9164b17c8cc8c5178d850e7d4.svg";
export { ForwardRef as ReactComponent };